module.exports = __webpack_public_path__ + "img/PressReleasesCover.47c4b224.jpg";